import { Component, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

export type ButtonToggleColor = 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'neutral';
export type ButtonToggleSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

@Component({
  selector: 'button[app-button-toggle], a[app-button-toggle]',
  template: '<ng-content></ng-content>',
  styleUrls: ['./button-toggle.component.scss'],
  standalone: true,
})
export class ButtonToggleComponent {
  @Input() color: ButtonToggleColor = 'primary';
  @Input() size: ButtonToggleSize = 'sm';
  @Input() checked = false;
  @Input() value: any;
  @Input() disabled = false;

  @Output() select = new EventEmitter<any>();

  @HostBinding('class.button-toggle') readonly isButtonToggle = true;

  @HostBinding('attr.role') readonly role = 'radio';

  @HostBinding('attr.aria-checked') get ariaChecked(): string {
    return String(this.checked);
  }

  @HostBinding('attr.tabindex') get tabIndex(): number {
    return this.checked ? 0 : -1;
  }

  @HostBinding('attr.disabled') get isDisabled(): string | null {
    return this.disabled ? '' : null;
  }

  @HostBinding('class.button-toggle--checked') get isChecked() {
    return this.checked;
  }

  @HostBinding('class.button-toggle--unchecked') get isUnchecked() {
    return !this.checked;
  }

  @HostBinding('class.button-toggle--xs') get isXs() {
    return this.size === 'xs';
  }
  @HostBinding('class.button-toggle--sm') get isSm() {
    return this.size === 'sm';
  }
  @HostBinding('class.button-toggle--md') get isMd() {
    return this.size === 'md';
  }
  @HostBinding('class.button-toggle--lg') get isLg() {
    return this.size === 'lg';
  }
  @HostBinding('class.button-toggle--xl') get isXl() {
    return this.size === 'xl';
  }

  @HostBinding('class.button-toggle--primary') get isPrimary() {
    return this.color === 'primary';
  }

  @HostBinding('class.button-toggle--success') get isSuccess() {
    return this.color === 'success';
  }

  @HostBinding('class.button-toggle--warning') get isWarning() {
    return this.color === 'warning';
  }

  @HostBinding('class.button-toggle--danger') get isDanger() {
    return this.color === 'danger';
  }

  @HostBinding('class.button-toggle--info') get isInfo() {
    return this.color === 'info';
  }

  @HostBinding('class.button-toggle--neutral') get isNeutral() {
    return this.color === 'neutral';
  }

  @HostListener('click')
  onClick(): void {
    if (!this.disabled) {
      this.select.emit(this.value);
    }
  }
}
